module.exports = __webpack_public_path__ + "img/screenforce-logo.9bc3780d.jpeg";